import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResultFormBgComponent } from './result-form-bg.component';
import { FitTextModule } from '@shared/components/games';

@NgModule({
  declarations: [ResultFormBgComponent],
  imports: [CommonModule, FitTextModule],
  exports: [ResultFormBgComponent],
})
export class ResultFormBgModule {}
